import { ActivityIndicator } from 'react-native'
import { colors } from 'infra/color'
import React from 'react'

export const Loading = () => (
  <ActivityIndicator color={colors.primary} style={{ flex: 1 }} size='large' />
)
